import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import PageHome from "./containers/PageHome";
import PageBrand from "./containers/PageBrand";
import { ThemeProvider } from "styled-components";
import { theme, GlobalStyle } from "./utils/theme";
import styled from "styled-components";

const Header = styled.nav`
  padding: 1rem 2rem;
  background: #fff8ef;
  border-bottom: 1px solid #dccbb4;
  display: flex;
  gap: 1.5rem;
  position: sticky;
  top: 0;
  z-index: 10;

  a {
    color: #7a5835;
    font-weight: 600;
    text-decoration: none;
    transition: 0.25s ease;
  }

  a:hover {
    color: #c48a4a;
  }
`;

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Router>
          <Header>
            <Link to="/">首頁</Link>
            <a href="#intro">活動介紹</a>
            <a href="#schedule">活動時程</a>
            <a href="#map">參與品牌地圖</a>
            <a href="#lottery">抽獎辦法</a>
            <a href="https://www.tw-cuisine.tw/2025sesameoil/" target="_blank">閱讀電子書</a>
          </Header>

          <div style={{ padding: "1rem" }}>
            <Routes>
              <Route path="/" element={<PageHome />} />
              <Route path={`/brand/:id?`} element={<PageBrand />} />
            </Routes>
          </div>
        </Router>
      </ThemeProvider>
    </>
  );
}

export default App;
